<template>
    <form class="form-horizontal">
        <b-form-group
            :label-for="`name_on_card`"
            label="Name on Card:"
            label-cols="3"
        >
            <b-form-input
                id="name_on_card"
                v-model="data.name_on_card"
                v-validate="'required'"
                :class="{ 'border-danger': errors.has('name_on_card') }"
                name="name_on_card"
                autofocus
            />
        </b-form-group>
        <b-form-group>
            <div v-show="cc_iframe_load" class="iframe_label_p">
                <label id="card_number">Card Number:</label>
                <label id="expiration">Expiration:</label>
                <label id="scode">Security Code</label>
                <a id="tip" href="#" @click.prevent>
                    <i
                        v-b-popover.hover.bottom="
                            'For Visa, MasterCard, and Discover, the security code is the last 3 digit number located on the back of the card or above the signature line. For American Express, it is the 4 digits on the front of the card above the end of the card number.'
                        "
                        class="cus-information"
                        container="app"
                        title="Note"
                    ></i> </a
                >:
            </div>
            <div
                v-show="cc_iframe_load"
                id="iframe_content"
                class="iframe_content"
            >
                <iframe
                    id="tokenframe_p"
                    name="tokenframe"
                    :src="data.cardconnect_iframe_url"
                    frameborder="0"
                    scrolling="no"
                    @load="$emit('iframe-loaded')"
                ></iframe>
            </div>
        </b-form-group>
    </form>
</template>
<script>
import PaymentDialogHelper from "@/module/payment/helper.js";

export default {
    mixins: [PaymentDialogHelper],
    props: {
        data: {
            type: Object,
            default() {
                return {
                    id: null,
                    name_on_card: null,
                    card_number: null,
                    expiry_month: "",
                    expiry_year: "",
                    security_code: null,
                    is_primary: "1",
                    existing_pmp: 0,
                    direct: -1
                };
            }
        }
    },
    data() {
        return {
            resources: {},

            year_options: [],
            cc_iframe_load: false
        };
    },
    watch: {
        "data.cardconnect_iframe_url": {
            handler(value) {
                if (value && value.includes("cardconnect.com")) {
                    this.$once("iframe-loaded", () => {
                        setTimeout(() => {
                            this.$emit("loaded");
                            this.cc_iframe_load = true;
                            let self = this;

                            window.addEventListener(
                                "message",
                                function (event) {
                                    self.data.myerror = "";
                                    let token = JSON.parse(event.data);

                                    if (
                                        typeof token.message !== "undefined" &&
                                        typeof token.expiry !== "undefined"
                                    ) {
                                        self.data.mytoken = token.message;
                                        self.data.myexpiry = token.expiry;
                                    } else {
                                        if (
                                            typeof token.validationError !==
                                            "undefined"
                                        ) {
                                            self.data.myerror =
                                                token.validationError;
                                        }
                                    }
                                },
                                false
                            );
                        }, 350);
                    });
                } else {
                    this.cc_iframe_load = false;
                }
            },
            immediate: true
        }
    },
    methods: {
        getPaymentMethodProfile() {
            this.$http
                .get(
                    process.env.PAYMENT_SERVICE +
                        "payment-method?entity_id=" +
                        _.get(
                            this,
                            "data.client.id",
                            this.$root.setting.business_id
                        ) +
                        "&entity_type=" +
                        this.data.entity
                )
                .then(response => {
                    if (response.data.response.resources.data.length > 0) {
                        this.data.existing_pmp = 1;
                        this.data.is_primary = "0";
                    }
                });
        }
    }
};
</script>
<style>
#name_on_card {
    margin-left: 0px;
}

#is_primary {
    margin-left: 5px;
}

iframe#tokenframe_p {
    width: 102%;
    height: 109px;
    margin-top: -8px;
    margin-left: -0.25rem;
}

.iframe_label_p {
    width: 25%;
    height: 100px;
    float: left;
}

.iframe_label_p label#card_number {
    margin-top: 2px;
}

.iframe_label_p label#expiration {
    margin-top: 8px;
}

.iframe_label_p label#scode {
    margin-top: 12px;
    margin-right: 0px;
    display: inline-block;
}

.cus-information {
    margin-right: 0px;
}

#tip {
    margin-right: -6px;
}

.iframe_content {
    width: 75%;
    float: right;
}

@media only screen and (max-width: 300) {
    .iframe_label_p label#scode {
        display: unset;
    }
}
</style>
